import { z } from 'zod';

import { finNoAnteriorAInicio, ISO_DATE_RE } from '@/shared/lib';

/**
 * Schema del Paso 3 (Fases y Subfases) — fechas de la fase activa
 * (Construcción por default). Espeja la regla del Paso 1 (Datos
 * generales): fechas ISO `YYYY-MM-DD` y fin ≥ inicio.
 *
 * El cableado contra el backend se difiere; este schema vive para
 * que los DatePickers del paso usen `aria-invalid` + mensajes
 * inline consistentes con el resto del wizard.
 */
export const pasoFasesSchema = z
  .object({
    faseInicio: z.string().regex(ISO_DATE_RE, 'Fecha requerida.'),
    faseFin: z.string().regex(ISO_DATE_RE, 'Fecha requerida.'),
  })
  .refine(
    ...finNoAnteriorAInicio(
      'faseInicio',
      'faseFin',
      'Debe ser igual o posterior a la fecha de inicio.',
    ),
  );

export type PasoFasesValues = z.infer<typeof pasoFasesSchema>;
